module.exports = "mutation ($id: ID!) {\n  FlatfinderDelete(id: $id) {\n    id\n  }\n}\n"